import React from 'react'

import NavBar from '../landing/navbar'
import Footer from '../landing/footer'
import TermsContent from './TermsContent'
import './faq.scss'

const Terms = () => (
  <div className='faq-page'>
    <NavBar />
    <main className='container col-xxl-8 py-5'>
      <TermsContent />
    </main>
    <Footer />
  </div>
)

export default Terms
